
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import PricingTablesSingle from '@/components/Tradly/Single/PricingTablesSingle'
import Settingup from './_settingup.mdx'
import Storecustomisation from './_storecustomisation.mdx'
import Advancedfeatures from './_advancedfeatures.mdx'
import Growingstore from './_growingstore.mdx'
import Scaling from './_scaling.mdx'
import TemplatesCards from '../../Shared/TemplatesCard'
const Layout = require('@/layouts/RootFileLayout').RootFileLayout;
const meta = {
  "title": "FREE - How to Start an Online Store to sell Fashion Accessories with no-code needed",
  "date": "2022-12-01"
};
const slug = 'online-store-origami';
const tableOfContents = [{
  "title": "Register a free account",
  "slug": "register-a-free-account",
  "children": []
}, {
  "title": "Setting Up Store",
  "slug": "setting-up-store",
  "children": []
}, {
  "title": "Customising Store",
  "slug": "customising-store",
  "children": []
}, {
  "title": "Advanced Features",
  "slug": "advanced-features",
  "children": []
}, {
  "title": "Growing your Store",
  "slug": "growing-your-store",
  "children": []
}, {
  "title": "Scaling your Store",
  "slug": "scaling-your-store",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = require('@/layouts/CustomContentsLayout').CustomContentsLayout
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <p>{`Tradly makes it super easy to start a business and sell {} online. It takes only few minutes to open an online store and start selling {}. `}</p>
    <p>{`Tradly Commerce Software doesn’t look like software to you. It’s like your instagram to post your products. Super simple and easy to start. That’s the goal of Tradly Creator tools. A Free package to start and Easy to start your online business and grow your business. For Advanced use cases, Tradly have technical `}<a parentName="p" {...{
        "href": "https://developer.tradly.app"
      }}>{`Headless API level support`}</a>{` level features, but we would avoid any advanced or technical details in this article. `}</p>
    <p>{`It’s easy to launch your store with Tradly`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Register for free & Pay as you grow`}</li>
      <li parentName="ul">{`Customise your template with simple toggle & form based input `}</li>
      <li parentName="ul">{`Add Integrations without any code or technical implementations`}</li>
    </ul>
    <_Heading level={2} id={"register-a-free-account"} nextElement={{
      "type": "jsx"
    }}>Register a free account</_Heading>
 <div class="relative">
        <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/signup-tradly.png" />
      </div>
    <p><_Link href="/signup" passHref><a>{`Signup`}</a></_Link></p>
    <TemplatesCards category_id={4283} title={'Free Online Store Templates'} isShowBtn={true} mdxType="TemplatesCards" /> 
    <_Heading level={2} id={"setting-up-store"} nextElement={{
      "type": "jsx"
    }}>Setting Up Store</_Heading>
    <Settingup mdxType="Settingup" />
    <_Heading level={2} id={"customising-store"} nextElement={{
      "type": "jsx"
    }}>Customising Store</_Heading>
    <Storecustomisation mdxType="Storecustomisation" />
    <_Heading level={2} id={"advanced-features"} nextElement={{
      "type": "jsx"
    }}>Advanced Features</_Heading>
    <Advancedfeatures mdxType="Advancedfeatures" />
    <_Heading level={2} id={"growing-your-store"} nextElement={{
      "type": "jsx"
    }}>Growing your Store</_Heading>
    <Growingstore mdxType="Growingstore" />
    <_Heading level={2} id={"scaling-your-store"} nextElement={{
      "type": "jsx"
    }}>Scaling your Store</_Heading>
    <Scaling mdxType="Scaling" />
    <PricingTablesSingle mdxType="PricingTablesSingle" />



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
